import { render, staticRenderFns } from "./CommunityStats.vue?vue&type=template&id=63334a70"
import script from "./CommunityStats.vue?vue&type=script&lang=js"
export * from "./CommunityStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports